import { createEffect } from 'effector';

import { HospitalityService } from 'apps/request/services';

export const getIntakePartnerDetailsByUserId = createEffect({
  handler: HospitalityService.getIntakePartnerDetails,
});
